<template>
  <div class="message sms-wrapper">
    <div class="data-description" v-if="!classicCampaignsEnabled" style="margin-bottom:10px">
      <b>stashboard creator</b>

      <div>
        use the creator below to craft whatever message you want! add text, creative images, and extensions to your campaign and we will generate a stashboard for your members
        (<a href="https://springbig.zendesk.com/hc/en-us/articles/1500010744021-Webinar-The-Next-Level-of-Texting-with-stashboards" target="_blank">see tutorial</a>)
      </div>
    </div>
    <template v-if="!useCampaignEditor2">
      <header class="bg-blue-300 rounded-t-2xl p-4 flex justify-center flex-row">
        <CampaignCreatorHeader
          :current-merchant="currentMerchant"
          :stashboard-headers="stashboardHeaders"
          :ownerType="ownerType"
          :scopeId="messageId"
          />
      </header>
      <stashboardMediaUploader
        :assignedModuleRoute="assignedModuleRoute"
      />
    </template>
    <campaign-creator
      v-if="useCampaignEditor2"
      :ownerType="ownerType"
      :message="message"
      :campaign="campaign"
      :editorValue="smsContent"
      style="margin-bottom:10px;"
      @update:campaign="updateCampaign"
    />


    <div class="sms-and-extentions" v-if="!useCampaignEditor2">
      <sms
          :activeMessage="activeMessage"
          :messageModuleName="messageModuleName"
          :isRounded="referredMessaged"
          :smsSend="smsSend"
          :smsContent="smsContent"
          @updateCampaign="updateCampaign"
          @updateInvalidCharacters="updateInvalidCharacters">
      </sms>
      <extensions
          v-if="!isBackup && !classicCampaignsEnabled"
          :campaignSendTime="campaignSendTime"
          :isBudzAutoCampaign="isBudzAutoCampaign"
          :messageModuleName="messageModuleName"
          :messageType="messageType"
          :messageTypeId="messageId"
          :referredMessaged="referredMessaged"
          @updateCampaign="updateCampaign">
      </extensions>
    </div>
  </div>
</template>

<script>
  import Extensions from '../Extensions/Extensions'
  import { mapState, mapGetters } from 'vuex'
  import Sms from '../Sms/Sms'
  import TextNotificationPicker from "../TextNotificationPicker";
  import CampaignCreator from "../Campaigns/campaign-creator";
  import CampaignCreatorHeader from "../Campaigns/campaign-creator-header.vue"
  import stashboardMediaUploader from "../Campaigns/stashboard-media-uploader/stashboard-media-uploader.vue"
  import { stashboardAPI } from '../../services/api/stashboardAPI';

  export default {
    props: {
      ownerType: String,
      campaign: Object,
      message: Object,
      activeMessage: Boolean,
      campaignSendTime: String,
      isBudzAutoCampaign: Boolean,
      messageModuleName: {
        default: 'message',
        type: String
      },
      messagePriority: Number,
      smsSend: Boolean,
      assignedModuleRoute: String
    },

    name: 'Message',

    components: {
      Extensions,
      Sms,
      TextNotificationPicker,
      CampaignCreator,
      CampaignCreatorHeader,
      stashboardMediaUploader
    },

    data() {
      return {
        invalidCharacters: null,
        referredMessaged: false,
        showBackup: false,
        smsContent: '',
        stashboardHeaders: []
      }
    },

    methods: {
      updateCampaign(data) {
        this.$emit('update', data)
      },

      updateInvalidCharacters(invalids) {
        this.invalidCharacters = invalids
      }
    },

    async created() {
        this.referredMessaged = this.messagePriority === -1
        this.stashboardHeaders = await stashboardAPI.getStashboardHeaders()
    },

    computed: {
      ...mapState({
        isBackup (state) { return state[this.messageModuleName]?.isBackup },
        messageId (state) { return state[this.messageModuleName]?.messageId },
        messageType (state) { return state[this.messageModuleName]?.messageType }
      }),

      ...mapGetters(['classicCampaignsEnabled', 'useCampaignEditor2', 'currentMerchant']),

      moduleName: function() { return this.messageModuleName }
    },
  }
</script>

<style lang="css">
  .data-description b {
    font-size: 1.25rem
  }

  .notification-label, .notification-item {
    font-size: 1rem;
    text-align: left;
  }

  .notification-label-description, .notification-item-description {
    font-size: 1rem;
    font-family: AileronThin;
    text-align: left;
  }

  .notification-item-description {
    color: #128ff9;
    font-weight: bold;
  }
</style>
